module.exports = __webpack_public_path__ + "static/media/background.412a3c92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/background.jpg
// module id = 6088
// module chunks = 0